export default __webpack_public_path__ + "static/media/padel-platinum-featured.1344042e.png";